import { useEffect } from "react";
import { useTranslation } from "react-i18next";


function PetName({ setPetInfo, petInfo, setIsComplete, petType }) {
  const { t } = useTranslation();

  useEffect(() => {
    petInfo.name.length ? setIsComplete(true) : setIsComplete(false);
  }, [petInfo.name]);

  return (
    <div className="flex-col items-center justify-between h-full relative max-w-2xl mb-12">
      <div className="pt-12">
        <div className="font-poppins text-2xl text-yellow-700 font-bold">
          {t("tellUsAboutYourPet")}
        </div>
        <div className="font-poppins text-yellow-600 p-2">
          {t("createNutritionPlan")}
        </div>
      </div>
      <div className="mt-12 justify-center items-center flex">
        <div className="relative z-0 w-10/12 mb-6 group">
          <input
            onChange={(e) => {
              setPetInfo({ ...petInfo, name: e.target.value });
            }}
            type="name"
            name="petName"
            className="block py-2.5 px-0 w-full text-lg text-yellow-600 bg-transparent border-0 border-b-2 border-yellow-400 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-lime-500 focus:outline-none focus:ring-0 focus:border-lime-600 peer"
            placeholder=" "
            required={true}
            value={petInfo.name}
          />
          <label
            htmlFor="petName"
            className="peer-focus:font-medium font-poppins absolute left-0 text-sm text-yellow-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-600 peer-focus:dark:text-lime-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            {petType == 'dog' ? t("petName") : t("catPetName")}
          </label>
        </div>
      </div>
    </div>
  );
}

export default PetName;
